import { Add } from '@mui/icons-material';
import { Box, TableCell, TableRow } from '@mui/material';

import { FSSecondaryButton } from '@/ui/components/button/FSSecondaryButton';
import { thStyle } from '@/ui/components/table/Table.utils';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

export function AddTourEventsTableLastRow({
  onClickAddTourEvent,
}: {
  onClickAddTourEvent: () => void;
}) {
  return (
    <TableRow>
      <TableCell style={thStyle} colSpan={7}>
        <Box display={'flex'} alignItems={'center'}>
          <FSSecondaryButton onClick={onClickAddTourEvent}>
            <Add
              sx={{
                color: ColorsRaw.main.Navy_Light,
                fontSize: 18,
                mr: 1,
              }}
            />
            {translate('ProjectsTour.AddTourEventsModal.add-tour-event')}
          </FSSecondaryButton>
        </Box>
      </TableCell>
    </TableRow>
  );
}
